module.exports = __webpack_public_path__ + "static/media/16UNODC26.2e831c68.jpg";